<template>
  <b-modal
    hide-footer
    style="z-index: 99999"
    id="filter-modal"
    size="lg"
    :title="title"
  >
  </b-modal>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";

export default {
  components: {},
  name: "filter-modal",
  props: {
    order: null,
    title: "",
  },
  computed: {
    selectedOrder: {
      get() {
        return this.order;
      },
      set(value) {},
    },
  },
  methods: {},
};
</script>